import styled from "styled-components";
import * as React from "react";
import { getBasketCount, getLoggedInStatus } from "../../store/tixly";
import { AppState } from "../../store";
import { connect } from "react-redux";
import LoginButton from "./LoginButton";
import SecondaryNavigation from "../../aat/components/Navigation/SecondaryNavigation/SecondaryNavigation";
import BasketButton from "./BasketButton";

interface UserStatusProps {
    textColor: string;
}

const UserStatus = (props: UserStatusStateProps & UserStatusProps): JSX.Element => {
    React.useState(0);
    const { basketCount, isLoggedIn, textColor } = props;

    const navigateToLogIn = () => {
        window.open(`https://billet.aarhusteater.dk/da/login/?returnUrl=${window.location}`, "_self");
    };

    const navigateToBasket = () => {
        window.open("https://billet.aarhusteater.dk/da/buyingflow/order/", "_self");
    };

    return (
        <div>
            <SecondaryNavigation>
                <LoginButton textColor={textColor} navigateToLogIn={navigateToLogIn} isLoggedIn={isLoggedIn} />
                <BasketButton textColor={textColor} basketCount={basketCount} navigateToBasket={navigateToBasket} key={basketCount} />
            </SecondaryNavigation>
        </div>
    );
};

type UserStatusStateProps = ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: AppState) => {
    return {
        basketCount: getBasketCount(state.tixly),
        isLoggedIn: getLoggedInStatus(state.tixly)
    };
};

export default connect(mapStateToProps, null)(UserStatus);
